import { useTranslation } from "react-i18next";

export default function V2ExternalLoadPanel() {
  const { t } = useTranslation();
  return (
    <section className="mt-6 rounded-[10px] border border-dashed border-[rgba(98,94,166,0.45)] p-7 text-v2-muted">
      <h2 className="mb-2 font-display uppercase text-[#f4f2ff]">{t("v2.overview.external_load")}</h2>
      <p>{t("v2.overview.external_placeholder")}</p>
    </section>
  );
}
